module.exports = __webpack_public_path__ + "img/tree-4.8733e258.png";